import React from 'react';
import RichText from '@hig/rich-text';

const PageTextContents = (props) => {
  return (
    <RichText>
      <h1>{props.pageTitle}</h1>
      <p>{props.pageDescription}</p>
    </RichText>
  )
}

export default PageTextContents;
